// extracted by mini-css-extract-plugin
export default {"ellipsis":"IM7UPlbkuqr_BHAiYXyQ","wrapper":"A03oXMheI78fhG4LtcAL","spin":"p0tzA2e_jjJtsuk_tWkf"};